import gsap from "gsap";

const selectors = {
  overlay: ".country-select-container-overlay",
  inner: ".country-select-container-inner",
  close: ".country-select-close",
  submit: ".country-select-submit",
  dropdown: ".country-select-dropdown",
  form: "form#localization_form",
  item: ".country-select-item"
};

/** Initialize only once
 * @type {boolean}
 */
let initialized = false;

/** @type {(string|false)} */
let selectedCountry = false;

/** @type {boolean} */
let isOpen = false;

/**
 *
 * @param {HTMLElement} triggerElement
 */
export function init(triggerElement) {
  if (initialized === true) return;

  // Collect modal elements
  const overlayEl = document.querySelector(selectors["overlay"]);
  const innerEl = document.querySelector(selectors["inner"]);
  const closeEl = document.querySelector(selectors["close"]);

  const showModal = () => {
    if (overlayEl instanceof HTMLElement) {
      gsap.to(overlayEl, { opacity: 1, pointerEvents: "all" });
    }
  };
  const hideModal = () => {
    if (overlayEl instanceof HTMLElement) {
      gsap.to(overlayEl, { opacity: 0, pointerEvents: "none" });
    }
  };

  // Open modal when trigger is clicked
  triggerElement.addEventListener("click", () => showModal());

  // Close modal when user clicks away
  overlayEl.addEventListener("click", ({ target }) => {
    // Check if click event happened inside the inner element
    if (target instanceof Element && !target.closest(selectors.inner)) {
      hideModal();
    }
  });

  // Close modal when user clicks on the "X" icon
  closeEl.addEventListener("click", () => {
    hideModal();
  });

  // Collect form elements
  const formEl = document.querySelector(selectors.form);
  const inputEl = formEl.querySelector('input[name="country_code"]');

  if (formEl instanceof HTMLFormElement) {
    // Listen for submit events
    formEl.addEventListener("submit", event => {
      // Prevent default reload
      event.preventDefault();
      // Check that a country as been selected
      if (inputEl instanceof HTMLInputElement && selectedCountry) {
        // Set the input value of the form with selection
        inputEl.value = selectedCountry;
        // Fire submit
        formEl.submit();
      }
    });
  }

  // Collect dropdown elements
  const dropdownEl = document.querySelector(selectors.dropdown);
  const dropdownItems = document.querySelectorAll(selectors.item);

  const openDropdown = () => {
    gsap.to(dropdownEl, {
      height: "auto",
      duration: 0.2,
      ease: "expo",
      onComplete: () => {
        isOpen = true;
      }
    });
  };

  const closeDropdown = () => {
    gsap.to(dropdownEl, {
      height: "40px",
      duration: 0.2,
      ease: "expo",
      onComplete: () => {
        isOpen = false;
      }
    });
  };

  if (innerEl) {
    innerEl.addEventListener("click", ({ target }) => {
      if (
        target instanceof HTMLElement &&
        target.closest(selectors.item) &&
        !isOpen
      ) {
        // User clicked a inside
        openDropdown();
      } else {
        // User clicked away
        closeDropdown();
      }
    });
  }

  const updateDropdown = () => {
    dropdownItems.forEach(item => {
      if (item instanceof HTMLElement && "value" in item.dataset) {
        if (item.dataset.value === selectedCountry) {
          item.classList.add("current");
        } else {
          item.classList.remove("current");
        }
      }
    });
  };

  dropdownItems.forEach(item => {
    // Check that the item contains a data attribute called "value"
    if (item instanceof HTMLElement && "value" in item.dataset) {
      // List for clicks on every item
      item.addEventListener("click", () => {
        // Skip when the current item is clicked
        if (!item.classList.contains("current")) {
          // Update selected country store
          selectedCountry = item.dataset.value;
          // Apply DOM updates
          updateDropdown();
          // Close dropdown
          closeDropdown();
        }
      });
    }
  });

  initialized = true;
}
